import React from 'react';
import PropTypes from 'prop-types';

import ProductParameters from 'shared/product_tabs/tab_stencils/components/ProductParameters';
import { stencilsNames } from 'shared/product_tabs/tab_stencils/data/constants';

const Title = ({ stencilSide }) => {
  const text = stencilsNames[stencilSide];

  return (
    <h5 className="title">{text}</h5>
  );
};

const StencilItem = (props) => {
  const { productItem, reference, onChangeParameter, validator } = props;
  const { product, parameters } = productItem;

  return (
    <div className="stencil-item">
      <Title stencilSide={parameters.stencil_side} />
      <ProductParameters
        product={product}
        parameters={parameters}
        onChangeParameter={onChangeParameter}
        reference={reference}
        validator={validator} />
    </div>
  );
};

StencilItem.prototype = {
  reference: PropTypes.number.isRequired,
  productItem: PropTypes.shape({
    product: PropTypes.object.isRequired,
    parameters: PropTypes.object.isRequired,
    quantity: PropTypes.string.isRequired,
  }),
  onChangeParameter: PropTypes.func.isRequired,
};

export default StencilItem;
